import styled from "styled-components";

export const OutputContent = styled.div`
  display: grid;
  grid-template-columns: minmax(max-content, 200px) 200px 50px min-content;
  grid-column-gap: ${props => props.theme.spacersm};
  grid-row-gap: ${props => props.theme.spacersm};
  align-items: center;
`;
